module.exports = __webpack_public_path__ + "img/quality2.10f21716.png";